import { Injectable, inject, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CIPXDrawerManagerService, DrawerRef } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-manager.service';
import { ShoppingCartDrawerWrapper, ShoppingCartDrawerData } from '@sbd-doug-frontend/shared/lib/shopping-cart/shopping-cart-drawer.types';
import { ShoppingCartDrawerComponent } from './shopping-cart-drawer.component';

@Injectable({
  providedIn: 'root'
})
export class AccountPortalShoppingCartDrawerWrapperService implements ShoppingCartDrawerWrapper, OnDestroy {
  private _drawerManager = inject(CIPXDrawerManagerService);
  private _activeDrawerRef: DrawerRef<ShoppingCartDrawerComponent> | null = null;
  private _unsubscribeAll = new Subject<void>();

  openDrawer(data: ShoppingCartDrawerData): DrawerRef<ShoppingCartDrawerComponent> {
    // Close existing drawer if open
    if (this._activeDrawerRef) {
      // Update existing drawer data instead of creating a new one
      // this._activeDrawerRef.updateData(data); // If this method exists
      return this._activeDrawerRef;
    }

    // Open new drawer with account-portal specific styling/behavior
    this._activeDrawerRef = this._drawerManager.openDrawer(ShoppingCartDrawerComponent, {
      data,
      position: 'right',
      title: 'Shopping Cart'
    });

    // Set up cleanup when drawer is closed from any source (X button, ESC, etc.)
    this._activeDrawerRef.componentInstance.closeRequested
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(() => {
        this._activeDrawerRef = null;
      });

    return this._activeDrawerRef;
  }

  closeDrawer(): void {
    if (this._activeDrawerRef) {
      this._activeDrawerRef.close();
      this._activeDrawerRef = null;
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
